import React from "react";
import { useDebouncedCallback } from "use-debounce";

interface FormValidityProps {
  render: (
    isValid: boolean,
    onValidityChange: (isValid: boolean) => void,
    isDirty: boolean,
    onDirtyChange: (isDirty: boolean) => void
  ) => React.ReactElement;
  name?: string;
}

const FormValidity: React.FC<FormValidityProps> = (props) => {
  const [isValid, setIsValid] = React.useState<boolean>(true);
  const [isDirty, setIsDirty] = React.useState(false);

  const onValidityChange = useDebouncedCallback((validity: boolean) => {
    setIsValid(validity);
  }, 200);

  const onDirtyChange = useDebouncedCallback((change: boolean) => {
    setIsDirty(change);
  }, 200);

  return <>{props.render(isValid, onValidityChange, isDirty, onDirtyChange)}</>;
};

export default FormValidity;
